const parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(window.atob(base64));
};

const getTokenData = (element) => {
    return parseJwt(localStorage.getItem('token'))[element];
}

export default getTokenData;